import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Stack,
  MenuItem,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import chatApi from '../../api/chatApi';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function ChatRoomCreatePageDesktop() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    type: 'GENERAL'
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    setError(null);

    if (!form.name.trim()) {
      setError('Il nome della stanza è obbligatorio');
      return;
    }

    try {
      setLoading(true);
      await chatApi.createRoom(form);
      navigate('/rooms');
    } catch (err) {
      console.error(err);
      setError('Errore durante la creazione della stanza');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <BackButtonDesktop />

      <Typography variant="h4" sx={{ mb: 3 }}>
        Crea Nuova Stanza
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Stack spacing={3} sx={{ maxWidth: 500 }}>
        <TextField
          label="Nome Stanza"
          name="name"
          value={form.name}
          onChange={handleChange}
          fullWidth
          required
        />

        <TextField
          select
          label="Tipo Stanza"
          name="type"
          value={form.type}
          onChange={handleChange}
          fullWidth
        >
          <MenuItem value="GENERALE">Generale (tutti)</MenuItem>
          <MenuItem value="SOLO_CONTRIBUENTI">Solo Contribuenti</MenuItem>
          <MenuItem value="SOLO_STUDI">Solo Studi</MenuItem>
        </TextField>

        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            onClick={() => navigate('/chat')}
            disabled={loading}
          >
            Annulla
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Creazione...' : 'Crea Stanza'}
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}
